import React, { useEffect, useState } from "react";

interface IHtmlRendererProps {
	presignedUrl: string;
}

export const HtmlRenderer: React.FC<IHtmlRendererProps> = ({ presignedUrl }) => {
	const [htmlContent, setHtmlContent] = useState("");

	useEffect(() => {
		fetch(presignedUrl)
			.then((response) => response.text())
			.then((data) => {
				setHtmlContent(data);
			});
	}, [presignedUrl]);

	return <iframe
		title={"HtmlContent"}
		width="100%"
		height="100%"
		frameBorder={0}
		// This renders the raw, unsanitized HTML body of imported mails. Without sandboxing, a
		// non-sandboxed srcDoc iframe runs same-origin with this page, letting a <script> in the mail
		// read our localStorage session token (ROAD23-17070). Keep this empty: no allow-scripts,
		// no allow-same-origin (that combination would let the content remove its own sandbox).
		sandbox=""
		srcDoc={htmlContent} />;
};


